export const data = {
  foundit: {
    IN: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | foundit India",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.foundit.in/rio/login",
      siteName: "foundit India",
      mediaUrl:
        "//media.foundit.in/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-in"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "Quess House, 3/3/2 Bellandur Gate, Sarjapur Road,Bangalore,Karnataka",
          postalCode: "560103",
          addressCountry: "India",
        },
        name: "foundit.in India Pvt. Ltd.",
        telephone: "+91 - 80 - 4917 5600",
        url: "https://www.foundit.in/",
        logo: "https://media.foundit.in/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/monsterindia",
          "https://twitter.com/monster_india",
          "https://in.linkedin.com/company/monster-india",
          "https://www.instagram.com/monster_india/",
        ],
      },
    },
    SA: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | foundit Gulf",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.founditgulf.com/rio/login",
      siteName: "foundit Gulf",
      mediaUrl:
        "//media.founditgulf.com/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en", "ar"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "2203, 22nd Floor, Al Shafar Tower 1, Barsha Heights, TECOM",
          postalCode: "49360",
          addressCountry: "Dubai",
        },
        name: "foundit.in India Pvt. Ltd.",
        telephone: "8000177030,91-40 66116993",
        url: "https://www.founditgulf.com/",
        logo: "https://media.founditgulf.com/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/MonsterGULF",
          "https://twitter.com/monster_gulf",
          "https://www.youtube.com/user/MonsterGulfVideos",
        ],
      },
    },
    HK: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | foundit HK",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.foundit.hk/rio/login",
      siteName: "foundit Hong Kong",
      mediaUrl:
        "//media.foundit.hk/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-hk"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "Unit 1905,Empress Plaza, 17-19 Chatham Road South, Tsim Sha Tsui, Kowloon",
          addressCountry: "Hong Kong",
        },
        name: "foundit.HK Limited",
        telephone: "800960248,+91-40 66116589",
        url: "https://www.foundit.hk/",
        logo: "https://media.foundit.hk/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/monsterhk",
          "https://twitter.com/MonsterHongkong",
          "https://www.youtube.com/user/MonsterHKvideos",
        ],
      },
    },
    ID: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | foundit Indonesia",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.foundit.id/rio/login",
      siteName: "foundit Indonesia",
      mediaUrl:
        "//media.foundit.id/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-id"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: "Indonesia",
        url: "https://www.foundit.id/",
      },
    },
    MY: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | foundit Malaysia",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.foundit.my/rio/login",
      siteName: "foundit Malaysia",
      mediaUrl:
        "//media.foundit.my/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-my"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "Level 8, KYM Tower, Jalan PJU 7/6 Mutiara Damansara, 47800 Petaling Jaya, Selangor",
          addressCountry: "Malaysia",
        },
        name: "Agensi Pekerjaan Monster Malaysia Sdn. Bhd.",
        telephone: "18001 814 789,+91-40 66116988",
        url: "https://www.foundit.my/",
        logo: "https://media.foundit.my/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/pages/Monster-Malaysia/260612757328846",
          "https://twitter.com/MonsterjobsMY",
        ],
      },
    },
    PH: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | foundit Philippines",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.foundit.com.ph/rio/login",
      siteName: "foundit Philippines",
      mediaUrl:
        "//media.foundit.com.ph/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-ph"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "31st Floor, Yuchengco Tower, RCBC Plaza, 6819 Ayala Avenue, Makati City, Metro Manila",
          zipCode: "1227",
          addressCountry: "Philippines",
        },
        name: "foundit.com.ph",
        telephone: "1 80-011-101-060,0091-40-66116988",
        url: "https://www.foundit.com.ph/",
        logo: "https://media.foundit.com.ph/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/MonsterPhilippines",
          "https://twitter.com/MonsterjobsPH",
        ],
      },
    },
    SG: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | foundit Singapore",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.foundit.sg/rio/login",
      siteName: "foundit Singapore",
      mediaUrl:
        "//media.foundit.sg/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-sg"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality: "100 Beach Road, #27-10/13, Shaw Tower",
          postalCode: "189702",
          addressCountry: "Singapore",
        },
        name: "foundit.SG PTE LTD",
        telephone: "8001-012-339,+91-40 66116994",
        url: "https://www.foundit.sg/",

        logo: "https://media.foundit.sg/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/MonsterSingapore",
          "https://twitter.com/Monster_SG_1",
        ],
      },
    },
    TH: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | foundit Thailand",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.foundit.co.th/rio/login",
      siteName: "foundit Thailand",
      mediaUrl:
        "//media.foundit.co.th/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-th"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: "Thailand",
        url: "https://www.foundit.co.th/",
      },
    },
    VN: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | foundit Vietnam",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.foundit.vn/rio/login",
      siteName: "foundit Vietnam",
      mediaUrl:
        "//media.foundit.vn/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-vn"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: "Vietnam",
        url: "https://www.foundit.vn/",
      },
    },
  },
  monster: {
    IN: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | Monster India",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.monsterindia.com/rio/login",
      siteName: "Monster India",
      mediaUrl:
        "//media.monsterindia.com/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-in"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "Quess House, 3/3/2 Bellandur Gate, Sarjapur Road,Bangalore,Karnataka",
          postalCode: "560103",
          addressCountry: "India",
        },
        name: "Monster.com India Pvt. Ltd.",
        telephone: "+91 - 80 - 4917 5600",
        url: "https://www.monsterindia.com/",
        logo: "https://media.monsterindia.com/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/monsterindia",
          "https://twitter.com/monster_india",
          "https://in.linkedin.com/company/monster-india",
          "https://www.instagram.com/monster_india/",
        ],
      },
    },
    SA: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | MonsterGulf",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.monstergulf.com/rio/login",
      siteName: "Monster Gulf",
      mediaUrl:
        "//media.monstergulf.com/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en", "ar"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "2203, 22nd Floor, Al Shafar Tower 1, Barsha Heights, TECOM",
          postalCode: "49360",
          addressCountry: "Dubai",
        },
        name: "Monster.com India Pvt. Ltd.",
        telephone: "8000177030,91-40 66116993",
        url: "https://www.monstergulf.com/",
        logo: "https://media.monstergulf.com/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/MonsterGULF",
          "https://twitter.com/monster_gulf",
          "https://www.youtube.com/user/MonsterGulfVideos",
        ],
      },
    },
    HK: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | Monster HK",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.monster.com.hk/rio/login",
      siteName: "Monster Hong Kong",
      mediaUrl:
        "//media.monster.com.hk/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-hk"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "Unit 1905,Empress Plaza, 17-19 Chatham Road South, Tsim Sha Tsui, Kowloon",
          addressCountry: "Hong Kong",
        },
        name: "Monster.com.HK Limited",
        telephone: "800960248,+91-40 66116589",
        url: "https://www.monster.com.hk/",
        logo: "https://media.monster.com.hk/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/monsterhk",
          "https://twitter.com/MonsterHongkong",
          "https://www.youtube.com/user/MonsterHKvideos",
        ],
      },
    },
    ID: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | Monster Indonesia",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.monster.co.id/rio/login",
      siteName: "Monster Indonesia",
      mediaUrl:
        "//media.monster.co.id/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-id"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: "Indonesia",
        url: "https://www.monster.co.id/",
      },
    },
    MY: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | Monster Malaysia",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.monster.com.my/rio/login",
      siteName: "Monster Malaysia",
      mediaUrl:
        "//media.monster.com.my/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-my"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "Level 8, KYM Tower, Jalan PJU 7/6 Mutiara Damansara, 47800 Petaling Jaya, Selangor",
          addressCountry: "Malaysia",
        },
        name: "Agensi Pekerjaan Monster Malaysia Sdn. Bhd.",
        telephone: "18001 814 789,+91-40 66116988",
        url: "https://www.monster.com.my/",
        logo: "https://media.monster.com.my/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/pages/Monster-Malaysia/260612757328846",
          "https://twitter.com/MonsterjobsMY",
        ],
      },
    },
    PH: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | Monster Philippines",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.monster.com.ph/rio/login",
      siteName: "Monster Philippines",
      mediaUrl:
        "//media.monster.com.ph/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-ph"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality:
            "31st Floor, Yuchengco Tower, RCBC Plaza, 6819 Ayala Avenue, Makati City, Metro Manila",
          zipCode: "1227",
          addressCountry: "Philippines",
        },
        name: "Monster.com.ph",
        telephone: "1 80-011-101-060,0091-40-66116988",
        url: "https://www.monster.com.ph/",
        logo: "https://media.monster.com.ph/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/MonsterPhilippines",
          "https://twitter.com/MonsterjobsPH",
        ],
      },
    },
    SG: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | Monster Singapore",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.monster.com.sg/rio/login",
      siteName: "Monster Singapore",
      mediaUrl:
        "//media.monster.com.sg/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-sg"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        address: {
          "@type": "PostalAddress",
          addressLocality: "100 Beach Road, #27-10/13, Shaw Tower",
          postalCode: "189702",
          addressCountry: "Singapore",
        },
        name: "Monster.com.SG PTE LTD",
        telephone: "8001-012-339,+91-40 66116994",
        url: "https://www.monster.com.sg/",

        logo: "https://media.monster.com.sg/seeker_2014/seeker_responsive/images/companyLogo.svg",
        sameAs: [
          "https://www.facebook.com/MonsterSingapore",
          "https://twitter.com/Monster_SG_1",
        ],
      },
    },
    TH: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | Monster Thailand",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.monster.co.th/rio/login",
      siteName: "Monster Thailand",
      mediaUrl:
        "//media.monster.co.th/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-th"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: "Thailand",
        url: "https://www.monster.co.th/",
      },
    },
    VN: {
      title:
        "Jobseeker's Sign in - Search & Apply to Latest Jobs Online | Monster Vietnam",
      description:
        "Jobseeker's Login: Search & Apply jobs posted by top companies & consultants as per your skills, industry & locations. Update your resume for latest job vacancies.",
      url: "https://www.monster.com.vn/rio/login",
      siteName: "Monster Vietnam",
      mediaUrl:
        "//media.monster.com.vn/seeker_2014/seeker_responsive/images/mlogo.png",
      hrefLang: ["en-vn"],
      JSONLD: {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: "Vietnam",
        url: "https://www.monster.com.vn/",
      },
    },
  },
};
